import { GripVertical } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const GripVerticalIcon = createLucideIcon(GripVertical);
